import React from "react";
import DeviceShowcase from "../DeviceShowcase";

export default function PurchasingMockup() {
  const desktopUI = (
    <div className="w-full h-full flex flex-col text-sm bg-white">
      <div className="bg-slate-50 border-b border-slate-200 p-2 md:p-3 flex items-center justify-between">
        <span className="font-semibold text-slate-700 text-xs md:text-sm">
          Đơn Mua Hàng & Gia Công: #PO-BUY-2605
        </span>
        <span className="px-2 py-1 bg-green-100 text-green-700 rounded text-[10px] md:text-xs font-medium border border-green-200">
          Hoàn Tất Đặt
        </span>
      </div>
      <div className="p-3 md:p-4 flex-1 flex flex-col gap-4 overflow-auto">
        <div className="flex gap-4 p-3 bg-blue-50/50 border border-blue-100 rounded-lg">
          <div className="flex-1">
            <div className="text-[10px] md:text-xs text-slate-500">
              Nhà Cung Cấp
            </div>
            <div className="font-medium text-slate-800 text-xs md:text-sm">
              Công ty Giấy Bãi Bằng
            </div>
          </div>
          <div className="flex-1">
            <div className="text-[10px] md:text-xs text-slate-500">
              Ngày giao hàng
            </div>
            <div className="font-medium text-slate-800 text-xs md:text-sm">
              26/05/2026
            </div>
          </div>
          <div className="flex-1">
            <div className="text-[10px] md:text-xs text-slate-500">
              Tổng tiền thanh toán
            </div>
            <div className="font-bold text-indigo-700 text-xs md:text-sm">
              145,000,000 đ
            </div>
          </div>
        </div>

        <div className="space-y-2">
          <h4 className="text-xs font-bold text-slate-700 uppercase tracking-wider">
            Danh sách Đặt Mua
          </h4>
          <div className="border border-slate-200 rounded-md overflow-hidden shadow-sm">
            <table className="w-full text-left">
              <thead className="bg-slate-50 border-b border-slate-200 text-[10px] md:text-xs text-slate-500">
                <tr>
                  <th className="p-1.5 md:p-2 font-medium">Vật tư / Dịch vụ</th>
                  <th className="p-1.5 md:p-2 font-medium">Số lượng</th>
                  <th className="p-1.5 md:p-2 font-medium">Đơn giá</th>
                  <th className="p-1.5 md:p-2 font-medium text-right">
                    Thành tiền
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 text-[10px] md:text-xs">
                <tr>
                  <td className="p-1.5 md:p-2 font-medium text-slate-800">
                    Giấy Duplex 300gsm (Cuộn)
                  </td>
                  <td className="p-1.5 md:p-2">5 Tấn</td>
                  <td className="p-1.5 md:p-2">15,000 đ/kg</td>
                  <td className="p-1.5 md:p-2 text-right font-medium">
                    75,000,000 đ
                  </td>
                </tr>
                <tr>
                  <td className="p-1.5 md:p-2 font-medium text-slate-800">
                    Mực Offset Xanh (Cyan)
                  </td>
                  <td className="p-1.5 md:p-2">20 Thùng</td>
                  <td className="p-1.5 md:p-2">2,500,000 đ</td>
                  <td className="p-1.5 md:p-2 text-right font-medium">
                    50,000,000 đ
                  </td>
                </tr>
                <tr className="bg-orange-50/50">
                  <td className="p-1.5 md:p-2 font-medium text-orange-800">
                    Gia công: Phủ UV định hình
                  </td>
                  <td className="p-1.5 md:p-2 text-orange-700">10,000 Tờ</td>
                  <td className="p-1.5 md:p-2 text-orange-700">2,000 đ/tờ</td>
                  <td className="p-1.5 md:p-2 text-right font-medium text-orange-800">
                    20,000,000 đ
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );

  const mobileUI = (
    <div className="w-full h-full flex flex-col bg-slate-100">
      <div className="bg-white border-b border-slate-200 p-3 flex items-center justify-between z-10 sticky top-0">
        <div className="flex flex-col">
          <span className="text-[10px] text-slate-500 uppercase font-bold tracking-wider">
            Đề xuất Mua Vật tư
          </span>
          <span className="text-sm font-bold text-slate-800">#PR-2605-012</span>
        </div>
        <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center text-xs">
          🔔
          <div className="absolute top-2 right-2 w-2 h-2 bg-red-500 rounded-full border border-white"></div>
        </div>
      </div>

      <div className="flex-1 p-3 overflow-y-auto space-y-3 relative">
        <div className="bg-white p-3 rounded-xl border border-slate-200 shadow-sm relative overflow-hidden">
          <div className="absolute top-0 right-0 px-2 py-1 bg-amber-100 text-amber-700 text-[9px] font-bold rounded-bl-lg">
            CẦN DUYỆT GẤP
          </div>
          <div className="flex items-center gap-3 border-b border-slate-100 pb-2 mb-2">
            <div className="w-10 h-10 rounded bg-indigo-50 flex items-center justify-center text-indigo-600 font-bold">
              📜
            </div>
            <div>
              <div className="text-xs font-bold text-slate-800">
                Mua Giấy Cuộn Duplex
              </div>
              <div className="text-[10px] text-slate-500">
                Nguyên liệu Lệnh SX #PO-120
              </div>
            </div>
          </div>
          <div className="flex justify-between items-end">
            <div>
              <div className="text-[10px] text-slate-500 mb-0.5">
                Tổng ngân sách:
              </div>
              <div className="text-sm font-bold text-red-600">75,000,000 đ</div>
            </div>
          </div>
        </div>

        <div className="bg-white p-3 rounded-xl border border-slate-200 shadow-sm relative overflow-hidden">
          <div className="flex items-center gap-3 border-b border-slate-100 pb-2 mb-2">
            <div className="w-10 h-10 rounded bg-orange-50 flex items-center justify-center text-orange-600 font-bold">
              ✂️
            </div>
            <div>
              <div className="text-xs font-bold text-slate-800">
                Gia công Ép Kim
              </div>
              <div className="text-[10px] text-slate-500">
                Đối tác: Gia Công Anh Tuấn
              </div>
            </div>
          </div>
          <div className="flex justify-between items-end">
            <div>
              <div className="text-[10px] text-slate-500 mb-0.5">
                Phí gia công:
              </div>
              <div className="text-sm font-bold text-red-600">12,500,000 đ</div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white p-3 border-t border-slate-200 flex gap-2">
        <button className="flex-1 bg-indigo-600 text-white py-2 rounded-lg text-xs font-bold shadow-md shadow-indigo-200 transition-colors hover:bg-indigo-700">
          Duyệt Tất Cả (2)
        </button>
      </div>
    </div>
  );

  return <DeviceShowcase desktopUI={desktopUI} mobileUI={mobileUI} />;
}
